module.exports = __webpack_public_path__ + "static/media/custom-link.ee1f82b6.png";